import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorAlert } from "../../../../helpers/alerts";
import { createPINProductService } from "services/admin/productService";
import { addPINProduct } from "redux/slices/admin/productSlice";
import ProductForm from "components/admin/ProductForm";
import { setLoading } from "redux/slices/uiSlice";

const CreatePINScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlerSubmit = async (data) => {
    dispatch(setLoading(true))
    if (data.amounts)
      data.amounts = JSON.stringify(data.amounts);
    createPINProductService(null, data)
      .then((response) => {
        dispatch(addPINProduct(response));
        navigate(-1)
      })
      .catch(e => errorAlert(e))
      .finally(() => dispatch(setLoading(false)))
  };

  return (
    <ProductForm
      title="Crear Pin Electrónico"
      type={"pin"}
      goBack={() => navigate(-1)}
      submit={handlerSubmit}
    />
  );
};

export default CreatePINScreen;
